import { Box, CircularProgress, Typography } from '@mui/material';
import React from 'react';

function LoadingComponent({ fullScreen = true, textColor = "white", loadingText = "Worth the wait 💈"}) {
    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            gap={2}
            height={fullScreen ? "100vh" : "auto"}
            minHeight={fullScreen ? "100vh" : "100px"} // fallback for component view
            width="100%"
            zIndex={10000}
        >
            <CircularProgress color='secondary' />
            <Typography variant='h6' color={fullScreen ? 'textPrimary' : textColor}>{loadingText}</Typography>
        </Box>
    );
}

export default LoadingComponent;